var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlayorpark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Play_or_park",
    "data-name": "Play or park",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5451",
    "data-name": "Rectangle 5451",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14875",
    "data-name": "Group 14875",
    transform: "translate(3.152 3.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_31",
    "data-name": "Union 31",
    d: "M7597.155-3363.425a.5.5,0,0,1-.434-.25l-.523-.907a.5.5,0,0,1,.159-.667l6.662-4.376a.091.091,0,0,1,.016-.01,2.415,2.415,0,0,0,1.052-1.979,2.347,2.347,0,0,0-1-1.948.041.041,0,0,0-.013-.008l-6.714-4.41a.5.5,0,0,1-.159-.668l.525-.911a.5.5,0,0,1,.434-.25h8.326a1.466,1.466,0,0,1,1.267.731l3.36,5.822a3.288,3.288,0,0,1,0,3.278l-3.362,5.822a1.471,1.471,0,0,1-1.267.731Zm.144-15.131,6.314,4.147a3.364,3.364,0,0,1,1.473,2.8,3.423,3.423,0,0,1-1.524,2.827l-6.261,4.114.144.246h8.037a.466.466,0,0,0,.4-.231l3.36-5.82a2.294,2.294,0,0,0,0-2.281l-3.362-5.82a.46.46,0,0,0-.4-.231h-8.037Zm-3.99,12.593a1.49,1.49,0,0,1-.434-1.064c.011-2.481-.012-6.823-.027-9.189a1.49,1.49,0,0,1,.434-1.064,1.52,1.52,0,0,1,1.072-.447,1.488,1.488,0,0,1,.825.25l7.014,4.607a1.5,1.5,0,0,1,.676,1.257,1.5,1.5,0,0,1-.676,1.255l-6.987,4.59a1.5,1.5,0,0,1-.825.25A1.529,1.529,0,0,1,7593.308-3365.964Zm.682-10.612a.5.5,0,0,0-.141.354c.015,2.368.036,6.714.027,9.2a.481.481,0,0,0,.141.354.511.511,0,0,0,.363.153.5.5,0,0,0,.275-.086l6.987-4.59a.5.5,0,0,0,.227-.42.5.5,0,0,0-.227-.422l-7.012-4.607a.506.506,0,0,0-.277-.084A.525.525,0,0,0,7593.99-3376.576Z",
    transform: "translate(-7592.85 3379.809)",
    fill: "#65676a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayorpark);
export default __webpack_public_path__ + "static/media/icon_playorpark.e30120e3ba42516a48e2ac77d34110a8.svg";
export { ForwardRef as ReactComponent };